// Charge la base commune
// Styles librairies

// Styles custom
import './scss/pages/agencies'

// Scripts librairies
import 'waypoints/lib/jquery.waypoints.min.js'

// Pages
import { dtectMap } from './js/libs/utils.js'
import { agenciesPage } from './js/pages/agencies.page.js'

require('./common.js')

// Components
function getContactForm () {
  /* global pageLoading */
  pageLoading()
  import('./js/components/contact-form.js').then(() => {
    pageLoading(false)
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // à exécuter une fois la GMap API correctement chargée
  dtectMap(function () {
    agenciesPage.init()
  })

  const $cf = $('#contact-me')
  if ($cf.length) {
    $cf.waypoint(function () {
      getContactForm()
      this.destroy()
    }, {
      offset: '100%'
    })
  }
})
